export const LOAD_LIKES = "LOAD_LIKES";
export const ADD_LIKE = "ADD_LIKE";
export const REMOVE_LIKE = "REMOVE_LIKE";
